var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operatorAPI_page",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"card_add form-group"}),_c('div',{staticClass:"operators_list"},_vm._l((_vm.operators),function(operator,key){return _c('OperatorsAPIItem',{key:key,staticClass:"operator-item",attrs:{"operator":operator}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }